import MDB from '../../Core/marketingdb';

//Import boot functions
import {
    bootIndex as bootAnalysisSelectionIndex 
}  from '../Mangl/Modules/AnalysisSelection/index';

//setup namespacing
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.AnalysisSelection = MDB.Mangl.AnalysisSelection || {};

//setup boot functions
MDB.Mangl.AnalysisSelection.boot = bootAnalysisSelectionIndex;